export default __webpack_public_path__ + "static/media/logo.097ad814.svg";